import type {PayloadAction} from "@reduxjs/toolkit";
import {createSlice} from "@reduxjs/toolkit";

interface userState {
    user: any | null;
    accessToken: string | null;
}

const userFromStorage = localStorage.getItem('user');
const tokenFromStorage = localStorage.getItem('token');

const initialUserState: userState = {
    user: userFromStorage ? JSON.parse(userFromStorage) : null,
    accessToken: tokenFromStorage || null,
}

const userSlice = createSlice({
    name: "userSlice",
    initialState: initialUserState,
    reducers: {
        setCredentials: (state, action: PayloadAction<{ user: any; token: string }>) => {
            state.user = action.payload.user;
            state.accessToken = action.payload.token;
            localStorage.setItem('user', JSON.stringify(action.payload.user));
            localStorage.setItem('token', action.payload.token);
        },
        logout: (state) => {
            state.user = null;
            state.accessToken = null;
            localStorage.removeItem('token');
            localStorage.removeItem('user');
        }
    }
})

export const {setCredentials, logout} = userSlice.actions;
export default userSlice.reducer;